import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-no-location',
  templateUrl: './icon-no-location.component.html',
  styleUrls: ['./icon-no-location.component.scss']
})
export class IconNoLocationComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
